import React, { FC, useCallback, useEffect, useState } from "react";
import Header from "../../sections/Header";
import "../../css/DashBoard.css";
import { getRequestParams, service } from "../../../tools/service";
import imgWidget from "../../../assets/images/dashboard/widget.jpg";
import liImg from "../../../assets/images/dashboard/unactivated.png";
import ListWidget from "./dashboard/ListWidget";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../UI/Breadcrumbs";
import { isNull } from "lodash";

import GoogleAnalyticsConfiguration from "../../../googleAnalytics/googleAnalyticsConfiguration";

export interface widgets {
    id?: string;
    userName?: string;
    companies?: company[]
}
export interface company {
    city: string;
    id: string;
    img: string;
    name: string;
    place: string;
    services: serviceCompany[]
    state: string;
    streetAddress: string;
    themes: themeCompany[]
    zipCode: string;
    masterId: bigint;
}

export interface serviceCompany {
    id: string;
    serviceType: string;
    slotTypes: slotTypeCompany[]
}
export interface themeCompany {
    iconColor: string;
    id: string;
    primaryColor: string;
    primaryFont: string;
    secondaryColor: string;
}
export interface slotTypeCompany {
    id: string;
    jobTypes: jobTypeCompany[];
    slotFriendlyName: string;
    slotType: string;
}
export interface jobTypeCompany {
    groupName: string;
    id: string;
    jobClass: string;
    jobFriendlyName: string;
    jobType: string;
    jobTypeDesc: string;
}
const getDisplayName = () => {
    if (getRequestParams() && !localStorage.getItem("userName")) {
        const userInfo = getRequestParams() as any
        localStorage.setItem("userName", userInfo["userName"])
    }
}



const LitsWidgetDashBoard: FC = () => {
    const [userCompanies, setUserCompanies] = useState<widgets[]>();
    const [currentMasterId, setCurrentMasterId] = useState("");
    const breadcrumbs = [
        {
            redirect: "/admin",
            title: "Home"
        },
        {
            redirect: "",
            title: "Widget"
        }
    ]
    useEffect(() => {
        GoogleAnalyticsConfiguration.sendPageView("List Widgets");
        getMasterId()
        getDisplayName()
        getListOfCompaniesOfCurrentUser()
        localStorage.removeItem("service")
    }, [])
    const getListOfCompaniesOfCurrentUser = () => {
        const currentUserName = localStorage.getItem("userName") ?? ""
        service.get(`api/widgets/${currentUserName}`).then(response => {
            setUserCompanies(response.data)
        }).catch(error => {
            setUserCompanies([])
            return console.log("There are no data to display");
        });
    }
    function getMasterId() {
        const temp = getRequestParams() as any
        let data = {} as any
        data["masterId"] = temp.masterId
        service.post(`/api/masterId/decrypt`, data)
            .then(response => {
                setCurrentMasterId(response.data.masterId)
            })
    }
    const deleteCompany = useCallback(
        (widgetId: string, companyId: string, companyName: string) => {
            const proceedWithDelete = window.confirm(`Are you sure you want to delete this Booking Widget? This action cannot be reverted`);
            if (proceedWithDelete) {
                service.delete(`api/widgets/${widgetId}/company/${companyId}`)
                    .then(response => {
                        getListOfCompaniesOfCurrentUser();
                    })
            }
        }, [userCompanies]
    )
    const renderCompanies = () => {
        let companiesArray: JSX.Element[] = [];
        userCompanies?.forEach(widget => {
            widget.companies?.forEach(company => {
                if ((!isNull(company.masterId) && company.masterId.toString() == currentMasterId)) {
                    companiesArray.push(
                        <ListWidget
                            widgetId={widget.id ?? ""}
                            name={company.name}
                            companyId={company.id}
                            onClickDelete={() => deleteCompany(widget.id ?? "", company.id, company.name)}
                            masterId={currentMasterId}
                        />
                    );
                }
            })
        })
        if(companiesArray.length > 0)
            return companiesArray;
        return <div>No widgets to display</div>
    }

    return (
        <>
            <Header />
            <div className="h-full w-full  bg-customGray flex flex-col">
                <Breadcrumbs details={breadcrumbs} />
                <div className=" justify-center  max-w-6xl flex-row md:flex lg:ml-72 mb-3">
                    <div className="flex  flex-col md:w-1/2">
                        <p className="dashboard-title text-xl m-3 text-center md:text-left md:m-0 md:mt-3 md:mb-3 ">
                            Welcome Back To The Booking Widget,  {localStorage.getItem("userName") ?? ""}
                        </p>
                        <div className="hidden md:flex bg-white box-shadow h-full">
                            <div className="hidden md:flex md:w-1/2 "   >
                                <img src={imgWidget} alt="Example of a widget" />
                            </div>
                            <div className=" m-3 flex flex-col p-6 box-shadow-img rounded-r-md md:m-0 md:w-1/2 ">
                                <p className="text-customBlue font-bold text-2xl text-left">Make a New Booking Widget.</p>
                                <p className="pt-3 pb-3 text-lg">Answer a series of questions, save and share your widget within minutes.   </p>
                                <Link to="/admin/widget/create">
                                    <button
                                        className="mt-4 text-customBlue custom-btn-get-started w-full  "
                                    >GET STARTED</button>
                                </Link>
                            </div>
                        </div>
                        <div className="bg-white m-3 flex flex-col p-6 box-shadow  rounded-md md:m-0 md:w-full md:hidden">
                            <p className="text-customBlue font-bold text-lg text-center">Make a New Booking Widget.</p>
                            <p className="p-3">Answer a series of questions, save and share your widget within minutes. </p>
                            <button
                                className=" text-customBlue custom-btn-get-started w-3/4 mx-auto "
                            >GET STARTED</button>
                        </div>
                    </div>
                    <div className="flex flex-col md:w-1/2 ml-8 mt-3">
                        <p className="dashboard-title text-xl md:mb-3">How to host a widget:</p>
                        <ul className="list-none">
                            <li className="mb-2 flex">
                                <img src={liImg} alt="" className="mr-2 mt-1 w-4 h-4" />
                                <div className="line-height">
                                    <p className="customListWidget">STEP ONE</p>
                                    <p>copy the widget's script tag in the <strong>&lt;head&gt;</strong> section of your html.</p>
                                </div>

                            </li>
                            <li className="mb-2 flex">
                                <img src={liImg} alt="" className="mr-2 mt-1 w-4 h-4 " />
                                <div className="line-height">
                                    <p className="customListWidget">STEP TWO</p>
                                    <p><strong>ADD</strong>  <code><i>data-customer-link-widget="custom"</i> </code> to any html tag from which you want to launch the booking widget.</p>
                                </div>
                            </li>
                            <li className="mb-2 flex">
                                <img src={liImg} alt="" className="mr-2 mt-1 w-4 h-4" />
                                <div className="line-height">
                                    <p className="customListWidget">STEP THREE</p>
                                    <p><strong>Example</strong> of how the code should look</p>
                                </div>
                            </li>
                            <div className=" overflow-x-auto bg-customeCodebg box-shadow rounded-md md:ml-4 md:text-sm">
                                <code className="text-white ">
                                    <div className="m-3">
                                        &lt;html&gt;<br />
                                        &lt;head&gt;<br />
                                        &lt;title&gt;My Company Website&lt;/title&gt;<br />
                                        &lt;script id="successware-customer-link-widget" env="dev" companyId="2fd2ae1e-b5a0-4df3-9af4-7ea5f9fbf9b0" widgetId="b28143b8-d794-4b80-86a6-1c5a0eac0dd9" masterId="99124" src="https://bookit-dev.successware.com/widget/"&gt;<br />
                                        &lt;/script&gt;<br />
                                        &lt;/head&gt;<br />
                                        &lt;body&gt;<br />
                                        &lt;button data-customer-link-widget="custom"&gt;<br />
                                        &lt;/body&gt;<br />
                                        &lt;/html&gt;<br />
                                    </div>
                                </code>
                            </div>
                        </ul>
                        <p className=" md:ml-6 m-3 dashboard-title">Please have a certified/professional web designer modify your web page if you are
                            uncertain about adding a widget yourself.
                        </p>
                    </div>
                </div>
                <div className="  max-w-5xl flex-row md:flex lg:ml-72 mb-3 md:flex-col">
                    <p className="dashboard-title text-xl  text-center md:text-left mt-5 mb-5">
                        View and Edit Your Widgets
                    </p>
                    <div className="flex flex-col md:flex-row">
                        {userCompanies ? renderCompanies() : "No data to display"}
                    </div>
                </div>
            </div>
        </>
    )
}
export default LitsWidgetDashBoard;